title.abstract: Me
title.current-work: Stuff I’m Doing
title.work-history: Stuff I’ve Done
title.education: Where I Learned
title.buzzwords: Stuff I Know
title.patents: Patents
footer.copyright: Shawn Parker
